module.exports = __webpack_public_path__ + "mapdata/ci-all.geo.json";